<template>
    <v-container grid-list-md fluid>
        <v-card-text>
            <oss-data-table
                :headers="documentsHeaders"
                :items="documentAlsCreate"
                :fixed-header="true"
                :virtual-scroll="true"
                :striped="true"
                :dense="true"
                height="42vh"
                :loading="loading"
                :items-per-page="itemPerPage"
                :items-per-page-options="itemPerPages"
                :hide-default-footer="documentAlsCreate.length <= 50"
                :fixed-footer="true"
                class="table elevation-0"
            >
                <!-- class="table elevation-1"
                style="border-collapse: collapse;" -->
                <!-- :items-per-page="itemPerPage"
                :items-per-page-options="itemPerPages"
                :hide-default-footer="documentAlsCreate.length <=50"
                :fixed-footer="true"-->
                <template v-slot:item="props">
                    <tr>
                        <!-- // **** date ******* -->
                        <td>
                            {{ formatDate(props.item.date) }}
                        </td>

                        <!-- // **** accountableAccount ******* -->
                        <td
                            v-if="
                                props.item.accountableAccount &&
                                props.item.accountableAccount.connect &&
                                props.item.accountableAccount.connect.uniqueName &&
                                props.item.accountableAccount.connect.uniqueName.name
                            "
                        >
                            {{ props.item.accountableAccount.connect.uniqueName.name }}
                        </td>
                        <td
                            v-else-if="
                                props.item.accountableAccount &&
                                props.item.accountableAccount.connect &&
                                props.item.accountableAccount.connect.name
                            "
                        >
                            {{ props.item.accountableAccount.connect.name }}
                        </td>

                        <td
                            v-else-if="
                                props.item.accountableAccount && props.item.accountableAccount.name
                            "
                        >
                            <!-- {{props.item.accountableAccount.name}} - {{ props.item.accountableAccount.description || "" }} -->
                            {{ props.item.accountableAccount.name }}
                        </td>

                        <td v-else />

                        <!-- // **** wording ******* -->
                        <td>
                            {{ props.item.wording }}
                        </td>

                        <!-- // **** D ******* -->
                        <td
                            v-if="props.item.amountSigned && props.item.amountSigned > 0"
                            class="text-right"
                        >
                            {{
                                newCommonFormatCurrency(
                                    Math.abs(props.item.amountSigned),
                                    undefined,
                                )
                            }}
                        </td>

                        <td v-else />

                        <!-- // **** C ******* -->
                        <td
                            v-if="props.item.amountSigned && props.item.amountSigned < 0"
                            class="text-right"
                        >
                            {{
                                newCommonFormatCurrency(
                                    Math.abs(props.item.amountSigned),
                                    undefined,
                                )
                            }}
                        </td>

                        <td v-else />
                    </tr>
                </template>

                <template #body.append>
                    <tr style="font-weight: bold">
                        <th />
                        <th />
                        <th class="text-left">Totaux</th>

                        <!-- // ** debits -->
                        <th style="text-align: right" class="text-right">
                            <h3>{{ newCommonFormatCurrency(debits, undefined) }}</h3>
                        </th>

                        <!-- // ** credits -->
                        <th style="text-align: right" class="text-right">
                            <h3>{{ newCommonFormatCurrency(-credits, undefined) }}</h3>
                        </th>
                    </tr>
                </template>
            </oss-data-table>
        </v-card-text>
    </v-container>
</template>

<script lang="ts">
import moment from "moment-timezone";
// import { State2Way } from "@/decorators";
// import { Apollo } from "@/decorators";
import { isEmpty } from "lodash";
import { newCommonFormatCurrency } from "../../../../backend/src/common/services/mathServices";

import OssDataTable from "../ossComponents/ossDataTable2.vue";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component({
    components: {
        OssDataTable,
    },
})
export class GetEmptyDocumentsTable extends Vue {
    @Prop() readonly value: boolean;
    @Prop({ default: [] }) documentAlsCreate: Array<any>;
    @Prop({ default: [] }) accountableAccounts: Array<any>;

    newCommonFormatCurrency(value, options = undefined) {
        return newCommonFormatCurrency(value, undefined);
    }

    formatDate(date: string) {
        return moment(date).format("DD/MM/YYYY");
    }

    get loading() {
        if (isEmpty(this.documentAlsCreate)) return true;
        return false;
    }

    itemPerPages = [50, -1];
    _itemPerPage = 0;

    get itemPerPage() {
        if (!this._itemPerPage) {
            return this.documentAlsCreate.length <= 50 ? -1 : 50;
        }
        return this._itemPerPage;
    }

    set itemPerPage(value) {
        this._itemPerPage = value;
    }

    documentsHeaders: Array<any> = [
        {
            text: "Date",
            value: "date",
            align: "left",
            sortable: true,
        },
        {
            text: "Compte",
            value: "name",
            align: "left",
            sortable: true,
        },
        // {
        //     text: "",
        //     value: "description",
        //     align: "left",
        //     sortable: true
        // },
        {
            text: "Libéllé",
            value: "wording",
            align: "left",
            sortable: true,
        },
        {
            text: "Débit",
            value: "amountSigned",
            align: "right",
            sortable: true,
        },
        {
            text: "Credit",
            value: "amountSigned",
            align: "right",
            sortable: true,
        },
    ];

    get debits() {
        const positifs = this.documentAlsCreate.filter(
            (al) => al.amountSigned && al.amountSigned > 0,
        );

        let sum = 0;
        if (positifs && positifs.length) {
            sum = positifs.reduce((a, b) => a + b.amountSigned, 0);
        }
        return sum;
    }

    get credits() {
        const negatifs = this.documentAlsCreate.filter(
            (al) => al.amountSigned && al.amountSigned < 0,
        );

        let sum = 0;
        if (negatifs && negatifs.length) {
            sum = negatifs.reduce((a, b) => a + b.amountSigned, 0);
        }
        return sum;
    }

    // accountableAccountName(accountableAccountName) {
    //     if (this.accountableAccounts?.length) {
    //         const accountableAccount = this.accountableAccounts.find(aa => aa.name === accountableAccountName)
    //         if (accountableAccount) {
    //             return accountableAccount.name
    //         }
    //     }
    //     return ""
    // }
}

export default toNative(GetEmptyDocumentsTable);
</script>
